import React, { Component } from 'react';

import { Feedback, Dialog, Button, Grid, moment } from '@icedesign/base';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getFingers } from '@/api/DeptApi';
import {
  registerSdk,
  connect as connectSdk,
  stopReconnect,
  disconnect,
  createBlankKey,
  createUnlockKey,
  readUnlockRecords,
} from '@/api/HardwareApi';
import { getKey, createKeyDownloadRecord, getKeyAuther } from '@/api/KeyApi';
import { logout, getUserMessages } from '@/api/ProfileApi';
import { getLatestCommProgram, getSocketLink } from '@/api/SystemApi';
import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
import FingerprintDownloader from '@/components/FingerprintDownloader';
import KeyConnector from '@/components/KeyConnector';
import { formatMessage } from '@/i18n';
import { connect as connectMQTT, subscribeApprovals, subscribeElcAlarmMessage } from '@/mqtt';
import { setGuestNoticeVisible } from '@/store/actions/GuestActions';
import { setMQTTConnection } from '@/store/actions/MQTTActions';
import { updateMessages } from '@/store/actions/ProfileActions';
import {
  setKeyModel,
  setKeyMultiTask,
  setPadConnection,
  setReaderConnection,
  setSDKConnection,
  setSDKRegistration,
} from '@/store/actions/SDKActions';
import {
  setCommVersion,
  setDisableCommUpdater,
  setSystemTrialNoticeVisible,
} from '@/store/actions/SystemActions';
import Colors from '@/tool/Colors';
import EventEmitter, {
  KEY_MODE_UNSUPPORTED_UNLOCK,
  PAD_CONNECT_CHANGED,
  READER_CONNECT_CHANGED,
  SDK_CODE_MISMATCH,
  SDK_CONNECT_CHANGED,
  KEY_INIT,
  SDK_OCCUPIED_BY_OTHERS,
  AUTH_KEY_SUCCEED,
} from '@/tool/events';
import { getCurrentPlatfrom } from '@/tool/platform';
import {
  getProfile,
  getConfig,
  setConfig,
  removeToken,
  getToken,
  isTrialVersion,
  isWMSdk,
  getWillExpireDays,
  isGuest,
  isLicensable,
  isAdvancedTask,
  isMulti,
  isWMAdvancedUnlock,
} from '@/tool/profile';
import { compareVersions, isWindows, isIE } from '@/tool/tool';

import { getKeyStatus, fingerprint_keytypes } from '../pages/Key/data';

const alarmRing = new Audio('/images/alarm.wav');
const ASK_READ_UNREAD_EVENT_BEFORE_GIVEBACK = false;

// 是否是初次加载骨架的标志，用来做一些初始化操作;
let isInitialLoad = true;
// 是否曾经成功连接socket的标志，用来决定断开提示时是否显示下载通讯组件按钮;
let socketEverSucceed = false;
// SDK状态的监听器，只有第一次加载该组件时（isInitialLoad）为null/false;
let sdkListener = null;

let alarmToastCount = 0;

@withRouter
class Initializer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadingFingerprint: false,
    };
    this.keystatus = getKeyStatus();
    console.log('constructor');
  }

  // componentDidMount() {
  // 	// 为了兼容临时的无需用户登陆的工厂模式，加入了FactoryLayout布局和hnotVerifyLogin属性，代表不要求登录

  // 	// 坑啊！之前这里的逻辑放在了构造函数里面，意图更快的执行避免任何视觉渲染，但是却意外造成了与react-navigation缓存的关联bug
  // 	// 当清除缓存后，刷新页面，由于组件还没渲染就由于token为空回退到登录页，导致其他生命周期componentWillUnmount也没有执行，导致缓存的清空事件未执行

  // 	// 其实这里的逻辑不加也无妨，因为空token调用相关接口后会直接401重定向，初衷就是为了无token时直接退出而不需接口判断
  // 	if (!props.notVerifyLogin && !getToken()) {
  // 		props.history.replace('/login');
  // 	}
  // }

  playAlarm = () => {
    console.log('~~~~~~~~~~~~~~~~~~~~~~playAlarm~~~~~~~~~~~~~~~~~~`');
    alarmRing.loop = true;
    alarmRing.play();
  };

  stopAlarm = () => {
    alarmToastCount -= 1;
    if (alarmToastCount == 0) {
      alarmRing.pause();
      alarmRing.currentTime = 0;
    }
  };

  render() {
    const { downloadingFingerprint } = this.state;
    return (
      <div>
        <KeyConnector
          title={formatMessage('key.connector.read.keyinfo')}
          desc={formatMessage('key.connector.read.keyinfo.desc')}
          displayKey
          ref={com => {
            this.keyConnector = com;
          }}
        />

        <KeyConnector
          ref={com => {
            this.authKeyConnector = com;
          }}
          closeAfterRead={false}
        />
        <FingerprintDownloader
          visible={downloadingFingerprint}
          onFinish={() => this.setState({ downloadingFingerprint: false })}
        />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </div>
    );
  }

  componentDidMount() {
    // 加上token判断条件是为了在没有token直接进主页时，
    // 会先进主界面根据网络返回情况（token是否有效）回到登录页从而仍然执行这里使isInitLoad设置为false，导致登陆成功后不再显示提示;
    if ((this.props.notVerifyLogin || getToken()) && isInitialLoad) {
      console.log('---- Initializer ----');

      const days = getWillExpireDays();
      if (days <= 14 && isLicensable()) {
        this.showTrialExpiredNotification(days);
      }

      if (!isGuest() && !this.props.notVerifyLogin && !getProfile().email) {
        this.showMailEmptyNotification();
      }

      // 多任务版本时，只有不是ADMINISTRATOR人员提示
      if (!getAuthority().includes(Auths.ADMINISTRATOR)) {
        const enableConnect = !getConfig().disableSDK && (isWMSdk() ? true : isWindows());
        if (enableConnect) {
          // TODO: 是否需要处理连接报错的情况？
          console.warn('---- Connect SDK ----');
          connectSdk();

          // 这样做的缺点是linux支持cp2102，无法监控到发卡器的链接状态，虽然没什么卵用;
          if (!sdkListener) sdkListener = this.addSdkListener();
        }
      } else {
        // 断开socket
        disconnect();
        // 移除监听
        EventEmitter.removeAllListeners();
        sdkListener = null;
      }

      // TODO: 用mqtt代替
      if (getToken()) {
        // TODO: 这里最好使用单独的权限
        const hasApprovalAuth =
          getAuthority().includes(Auths.USER) &&
          (!isAdvancedTask()
            ? getAuthority().includes(Auths.auditKEY) &&
              getAuthority().includes(Auths.queryKEY_OUTIN)
            : getAuthority().includes(Auths.auditTASK));
        if (hasApprovalAuth) this.getApprovalCount();

        // 如果服务端返回了mqtt字段，代表支持mqtt，其中还包含port信息
        if (getProfile().mqtt) {
          connectMQTT(err => {
            this.props.dispatch(setMQTTConnection(!err));

            if (hasApprovalAuth) {
              subscribeApprovals(this.getApprovalCount);
            }
            // 全局订阅待审批
            // TODO: 目前手动unsubscribe

            // 订阅钥匙盒信息
            // console.log(initialMockKeybox);
            // TODO: 为了调试方便加入的临时假数据，后续移除
            // this.props.dispatch(setKeyboxes([initialMockKeybox]));

            // 企业总平台不需要Elc报警订阅
            if (!getAuthority().includes(Auths.ADMINISTRATOR)) {
              console.log('~~~~~~~~~~~~~subscribeElcAlarmMessage~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
              subscribeElcAlarmMessage(this.getElcAlarmDataMessage);
            }

            // subscribeKeybox(keybox => {
            //     console.log('setKeyboxes', keybox);
            //     // TODO: 测试使用，后续从后台取钥匙盒列表
            //     //  this.props.dispatch(setKeyboxes([initialMockKeybox]));
            // })
          });
        }
      }
      window.onlanguagechange = () => {
        // 防止在登陆页也弹出语言修改提示，写法不是很好。。。
        // TODO: 主要针对云服务版wm通讯组件已注册成功的情况 （overseas标志），是否需要单独判断一下；
        if (!isInitialLoad) {
          isInitialLoad = true;
          removeToken();
          Dialog.alert({
            title: ':(',
            content: formatMessage('languageChange'),
            locale: {
              ok: formatMessage('ok'),
            },
            afterClose: () => {
              this.props.history.replace('/login');
              window.location.reload();
            },
          });
        }
      };

      // 保证每次重新登录后，都重置了首页的相关notice状态；
      this.props.dispatch(setSystemTrialNoticeVisible(isTrialVersion()));
      this.props.dispatch(setGuestNoticeVisible(isGuest()));

      isInitialLoad = false;
      // this.showElcAlarmToast();
    }
  }

  getApprovalCount = () => {
    // TODO: messgae中包含待审批数量，目前无权限的情况下强制返回0
    // TODO: 目前仅有一个待审批数量authCount，是否可以考虑重新约定接扩

    // 针对可能出现的，创建完任务后，在页面回退之前已经获取到接口数据，后续切换页面将通知重新渲染刷掉的情况，加入一个延迟；
    setTimeout(() => {
      getUserMessages().then(
        data => {
          this.props.dispatch(updateMessages(data));
          if (data.authcount > 0) {
            this.showApprovalToast(data.authcount);
          }
        },
        () => {
          // TODO: 未捕获异常
        }
      );
    }, 1500);
  };

  // 接收报警详细信息
  getElcAlarmDataMessage = msg => {
    if (msg?.alarmtype == 0 || msg?.alarmtype == 1 || msg?.alarmtype == 2) {
      alarmToastCount += 1;
      setTimeout(() => {
        this.showElcAlarmToast(msg);
      }, 1500);
    }
  };

  checkAvailableComm = sdkInfo => {
    getLatestCommProgram(getCurrentPlatfrom().id).then(program => {
      console.warn('getLatestCommProgram', getCurrentPlatfrom().id, program);
      if (
        program.version &&
        // 通讯组件没有返回version字段，代表是通讯组件未规范版本号之前的版本，肯定是老版本
        (!sdkInfo.version ||
          // 通讯组件返回version字段，但是小于线上通讯组件版本
          compareVersions(sdkInfo.version, program.version) < 0)
      ) {
        this.showCommAvailableToast(program);
      }
    });
  };

  addSdkListener() {
    console.warn('---- Add SDK Litsener ----');
    // 发卡器连接状态变化监听器
    // 第二个model参数只有WM会用到（可能有值，设备型号或null）
    EventEmitter.on(READER_CONNECT_CHANGED, (status, model, multitask) => {
      console.warn('---- Reader Connect Changed ----', status);
      this.props.dispatch(setReaderConnection(status));

      this.props.dispatch(setKeyModel(model));
      this.props.dispatch(setKeyMultiTask(multitask));
      // status ? this.showReaderConnectedNotification() : this.showReaderDisconnectedNotification();
    });
    EventEmitter.on(PAD_CONNECT_CHANGED, status => {
      console.warn('---- PAD Connect Changed ----', status);
      this.props.dispatch(setPadConnection(status));
    });
    // socket连接状态变化监听器
    EventEmitter.on(SDK_CONNECT_CHANGED, status => {
      console.warn('---- SDK Connect Changed ----', status);
      this.props.dispatch(setSDKConnection(status));
      // 连接成功
      if (status) {
        // this.showSDKSuccessNotification();
        // 貌似加个延时可以避免服务恢复后，发送注册命令无返回的问题？？？？
        // TODO: 后期再测试一下这边的问题，把延时去掉
        setTimeout(() => {
          console.warn('---- Register SDK ----');
          let registerTimer = null;
          let registerDialog = null;
          registerSdk()
            .then(
              sdkInfo => {
                // NOTE: 只有连接的后台大于4.5.0才支持通讯组件版本管理，防止调用旧接口时404；
                // TODO: 可以考虑系统初始化/登录后后台直接返回最新通讯组件版本
                const { version: serverVersion } = this.props.profileResult;
                if (isWMSdk() && serverVersion && compareVersions(serverVersion, '4.5.0') >= 0) {
                  if (!this.props.disableCommUpdater) {
                    this.checkAvailableComm(sdkInfo);
                  }
                  console.warn('---- Comm. Version ----');
                  console.warn(sdkInfo.version || sdkInfo.ver);
                  console.warn('-----------------------');
                  this.props.dispatch(setCommVersion(sdkInfo.version || sdkInfo.ver));
                }
                // TODO: 这个需要同样使用事件监听的模式吗？
                this.props.dispatch(setSDKRegistration(true));
              },
              err => {
                Feedback.toast.error(err);
              }
            )
            .finally(() => {
              if (registerDialog) registerDialog.hide();
              clearTimeout(registerTimer);
            });
          registerTimer = setTimeout(() => {
            registerDialog = Dialog.confirm({
              title: formatMessage('profile.notify.notice'),
              content: formatMessage('profile.notify.sdk.busy'),
              closable: 'close,mask,esc',
              footer: (
                <div>
                  <Button
                    onClick={() => {
                      registerDialog.hide();
                      registerDialog = null;
                    }}
                  >
                    {formatMessage('profile.notify.confirm')}
                  </Button>
                </div>
              ),
            });
            clearTimeout(registerTimer);
          }, 10000);
        }, 1500);
        // 连接成功以后（主要针对在连接详情界面进行的手动连接），如果当前用户设置的是不允许连接，则将配置改为允许连接
        if (getConfig().disableSDK) setConfig(Object.assign(getConfig(), { disableSDK: false }));
        // 连接成功以后，将socket曾成功连接的标志设置为true
        socketEverSucceed = true;
      } else {
        // Feedback.toast.prompt('连接通讯接口中断...');
        // TODO: 这里在个别情况下居然进行了反复的提示？难道是不停的连接成功与断开？？？？
        // TODO: 后期WM通讯组件支持非Windows平台后，再加入SDK类型判断条件；
        if (
          (isWMSdk() ? true : isWindows()) &&
          getToken() // 登录界面主动断开连接，会出发这里的事件，恢复登录后，这里的toast居然还会留存继续显示，所以判断一下是否有token来避免这种情况
        )
          this.showSDKErrorNotification();
        this.props.dispatch(setSDKRegistration(false));
      }
    });

    // 系统码不匹配时弹出通知提示，方便跳转初始化系统码页面
    // 由于B系列硬件不稳定，无法精准判断是否真的是系统码不匹配，所以目前仅C可用
    if (isWMSdk() && !isTrialVersion())
      EventEmitter.on(SDK_CODE_MISMATCH, () => {
        console.log('SDK_CODE_MISMATCH');
        console.log(getAuthority().includes(Auths.editKEY));
        console.log(this.props.history.location.pathname);
        if (
          getAuthority().includes(Auths.editKEY) &&
          this.props.history.location.pathname !== '/factory-wm'
        )
          this.showCodeMismatchToast();
      });

    if (isAdvancedTask()) {
      EventEmitter.on(KEY_MODE_UNSUPPORTED_UNLOCK, () => {
        if (getAuthority().includes(Auths.clearTASK)) {
          this.showResetKeyModeToast();
        }
      });
    }
    //  监听钥匙初始化提示
    EventEmitter.on(KEY_INIT, () => {
      this.showKeyInitToast();
    });

    EventEmitter.on(SDK_OCCUPIED_BY_OTHERS, () => {
      Dialog.alert({
        title: ':(',
        content: formatMessage('profile.notify.sdk.occupied'),
        locale: {
          ok: formatMessage('ok'),
        },
        afterClose: () => {
          // this.props.history.replace('/login');
          // window.location.reload();
        },
      });
    });

    return true;
  }

  showMailEmptyNotification() {
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          🚀&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage('profile.notify.email.notset')}
        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          <a
            onClick={() => {
              toast.dismiss(this.mailToaster);
              this.props.history.push('/profile');
            }}
            style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
          >
            👌&nbsp;{formatMessage('profile.notify.email.yes')}
          </a>
          <a
            onClick={() => toast.dismiss(this.mailToaster)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            😰&nbsp;{formatMessage('profile.notify.email.no')}
          </a>
        </div>
      </div>
    );
    this.mailToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }

  // showReaderConnectedNotification() {
  //     toast.info('🎉 发卡器已成功连接', {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //     });
  // }

  // showReaderDisconnectedNotification() {
  //     toast.warn('🎉 ' + formatMessage('profile.notify.reader.disconnect'), {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //     });
  // }

  // showSDKSuccessNotification() {
  //     toast.success('🎉 通讯组件已成功连接', {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //     });
  // }

  showTrialExpiredNotification(days) {
    const isAdmin = this.props.profileResult.username == 'admin';
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          💡&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {/* {formatMessage('system.license.almost.expired', '', { days })} */}
        {days >= 0
          ? formatMessage('system.license.almost.expired', '', { days: Math.abs(days) })
          : formatMessage('system.license.already.expired', '', { days: Math.abs(days) })}

        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          {(!isMulti() || getAuthority().includes(Auths.ADMINISTRATOR)) && (
            <a
              onClick={() => {
                if (isAdmin)
                  this.props.history.push({
                    pathname: '/system/license',
                    state: { bySystem: true },
                  });
                toast.dismiss(this.trialToaster);
              }}
              style={{ color: Colors.primary, fontWeight: '500' }}
            >
              👌&nbsp;
              {formatMessage(isAdmin ? 'system.license.know.admin' : 'system.license.know.normal')}
            </a>
          )}
        </div>
      </div>
    );
    this.trialToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }

  showSDKErrorNotification() {
    console.warn('connect i am show toast');
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          ⚡️&nbsp;{formatMessage('profile.notify.worse')}
        </div>
        {formatMessage('profile.notify.sdk.disconnect')}
        {!socketEverSucceed && (
          <span>
            {formatMessage('profile.notify.sdk.not.installed')}📌
            <a
              style={{ color: Colors.warning, fontWeight: 'bold' }}
              onClick={() => {
                this.getSocketService();
                toast.dismiss(this.sdkToaster);
              }}
            >
              {formatMessage('profile.notify.sdk.click.here')}
            </a>
            {formatMessage('profile.notify.sdk.download')}
          </span>
        )}
        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          {
            <div style={{ marginBottom: 10 }}>
              <a
                onClick={() => toast.dismiss(this.sdkToaster)}
                style={{ color: Colors.primary, fontWeight: '500' }}
              >
                😨&nbsp;{formatMessage('profile.notify.ok')}
              </a>
            </div>
          }
          <div>
            {!socketEverSucceed && (
              <a
                onClick={() => {
                  // TODO: 是否加入进一步提示和确认？
                  const dialog = Dialog.confirm({
                    title: formatMessage('profile.notify.notice'),
                    content: formatMessage('profile.notify.sdk.disabled'),
                    closable: 'close,mask,esc',
                    footer: (
                      <div>
                        <Button
                          onClick={() => {
                            dialog.hide();
                            this.dontUseSDK();
                            toast.dismiss(this.sdkToaster);
                          }}
                        >
                          {formatMessage('profile.notify.confirm')}
                        </Button>
                        <Button type="primary" onClick={() => dialog.hide()}>
                          {formatMessage('profile.notify.cancel')}
                        </Button>
                      </div>
                    ),
                  });
                }}
                style={{ color: Colors.lightGrey, fontWeight: '500' }}
              >
                😅&nbsp;{formatMessage('profile.notify.no.comm')}
              </a>
            )}
          </div>
        </div>
      </div>
    );
    this.sdkToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }

  showCodeMismatchToast = () => {
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          ❌&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage('profile.notify.code.mismatch')}

        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          <a
            onClick={() => {
              toast.dismiss(this.codeToaster);
              this.props.history.push('/writer');
            }}
            style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
          >
            👌&nbsp;{formatMessage('profile.notify.email.yes')}
          </a>
          <a
            onClick={() => toast.dismiss(this.codeToaster)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            🤔&nbsp;{formatMessage('profile.notify.email.no')}
          </a>
        </div>
      </div>
    );

    this.codeToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  showApprovalToast = count => {
    // TODO: 如果当前已经在领出页面时，点击跳转是无效的，也就没有办法进行筛选待审核;
    const jumpPath = isAdvancedTask() ? '/task/list' : '/record/key/outin';
    // 不能使用this.props.location.pathname，其值永远都是打开应用时的第一个url；
    const ignoreJump = this.props.history.location.pathname === jumpPath;
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          👀&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage(
          isAdvancedTask() ? 'task.approval.toast' : 'record.keyoutin.to.approve',
          '',
          { count }
        )}

        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          {ignoreJump || (
            <a
              onClick={() => {
                toast.dismiss(this.approvalToast);
                this.props.history.push({
                  pathname: jumpPath,
                  state: { authed: 0 },
                });
              }}
              style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
            >
              👌&nbsp;{formatMessage('record.keyoutin.approve.now')}
            </a>
          )}
          <a
            onClick={() => toast.dismiss(this.approvalToast)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            😷&nbsp;
            {!ignoreJump
              ? formatMessage('profile.notify.email.no')
              : formatMessage('profile.notify.ok')}
          </a>
        </div>
      </div>
    );
    this.approvalToast = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  showElcAlarmToast = alarmdata => {
    // 0-异常开门 1-异常开门 2-离线报警
    this.playAlarm();

    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          &nbsp;
          {alarmdata && alarmdata?.alarmtype == 2
            ? `⚡${formatMessage('record.elcalarmdata.alarmtype.offline')}`
            : alarmdata && alarmdata?.alarmtype == 0
            ? `❗${formatMessage('record.elcalarmdata.alarmtype.door.open')}`
            : `❗${formatMessage('record.elcalarmdata.alarmtype.door.close')}`}
        </div>
        <div>
          <Grid.Row style={{ fontWeight: 'bold', color: Colors.lightGrey }}>
            <div style={{ lineHeight: '28px' }}>
              {alarmdata?.alarmtype == 2 ? (
                <div>
                  {formatMessage('elcdoor.alarmdata.offline.remind', '', {
                    cabinetname: alarmdata?.cabinetname,
                    controller: alarmdata?.controllerno,
                  })}
                </div>
              ) : (
                <div>
                  {formatMessage('elcdoor.alarmdata.opendoor.erro', '', {
                    cabinetname: alarmdata?.cabinetname,
                    doorname: alarmdata?.doorname,
                    desc:
                      alarmdata?.alarmtype == 0
                        ? formatMessage('record.elcalarmdata.alarmtype.door.open')
                        : formatMessage('record.elcalarmdata.alarmtype.door.close'),
                  })}
                </div>
              )}
            </div>
          </Grid.Row>

          <Grid.Row style={{ fontWeight: 'bold', color: Colors.lightGrey }}>
            <div style={{ lineHeight: '28px' }}>
              {formatMessage('dashboard.elc.alarmdata.time')}：&nbsp;
              {alarmdata?.alarmtime}
            </div>
          </Grid.Row>
        </div>
        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          {getAuthority().includes(Auths.queryELCALARM_DATA) && (
            <a
              onClick={() => {
                toast.dismiss(alarmdataToast);
                this.props.history.push({ pathname: `/record/elcalarm` });
              }}
              style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
            >
              👀&nbsp;{formatMessage('dashboard.elc.alarmdata.detail')}
            </a>
          )}
          <a
            onClick={() => {
              toast.dismiss(alarmdataToast);
            }}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            👌&nbsp;{formatMessage('dashboard.elc.alarmdata.know')}
          </a>
        </div>
      </div>
    );
    const alarmdataToast = toast(content, {
      position: 'top-right',
      onClose: () => {
        this.stopAlarm();
      },
      autoClose: 30000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  showResetKeyModeToast = () => {
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          ✨&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage('task.key.reset.confirm')}

        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          <a
            onClick={() => {
              toast.dismiss(this.keyModeToast);
              this.props.history.push({
                pathname: '/task/list',
                state: { requireClear: true },
              });
            }}
            style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
          >
            👌&nbsp;{formatMessage('profile.notify.confirm')}
          </a>
          <a
            onClick={() => toast.dismiss(this.keyModeToast)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            🤔&nbsp;{formatMessage('profile.notify.cancel')}
          </a>
        </div>
      </div>
    );

    this.keyModeToast = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  showKeyInitToast = () => {
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          ❌&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage('profile.notify.key.init')}

        <div style={{ textAlign: 'right', margin: '15px 0' }}>
          <a
            onClick={() => {
              toast.dismiss(this.keyToaster);
              if (this.props.history.location.pathname === '/writer') {
                // NOTE: 为了解决在重置钥匙时，先重置了钥匙，然后想去重置锁，此时会提示需要初始化，而在此通知中点击跳转按钮时，由于当前路由重复，不会发生跳转动作
                // 方案1是隐藏跳转按钮
                // 方案2（当前采用）先重置路由，再跳转，居然非常神奇的也好用了
                this.props.history.replace('/writer');
                this.props.history.push('/writer');
              } else {
                this.props.history.push('/writer');
              }
            }}
            style={{ color: Colors.primary, fontWeight: '500', marginRight: 20 }}
          >
            👌&nbsp;{formatMessage('profile.notify.email.yes')}
          </a>
          <a
            onClick={() => toast.dismiss(this.keyToaster)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            🤔&nbsp;{formatMessage('profile.notify.email.no')}
          </a>
        </div>
      </div>
    );

    this.keyToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  toggleCommUpdater = status => {
    const that = this;
    if (!status) {
      const dialog = Dialog.confirm({
        title: formatMessage('profile.notify.notice'),
        content: formatMessage('system.comm.update.ignore.confirm'),
        closable: 'close,mask,esc',
        footer: (
          <div>
            <Button
              onClick={() => {
                dialog.hide();
                that.props.dispatch(setDisableCommUpdater(true));
                toast.dismiss(this.commToaster);
              }}
            >
              {formatMessage('profile.notify.confirm')}
            </Button>
            <Button type="primary" onClick={() => dialog.hide()}>
              {formatMessage('profile.notify.cancel')}
            </Button>
          </div>
        ),
      });
    } else {
      that.props.dispatch(setDisableCommUpdater(false));
    }
  };

  showCommAvailableToast = program => {
    const content = (
      <div style={{ margin: 10 }}>
        <div style={{ color: 'black', fontWeight: '600', fontSize: 18, marginBottom: 10 }}>
          📢&nbsp;{formatMessage('profile.notify.notice')}
        </div>
        {formatMessage('system.comm.update.available', null, { version: program.version })}

        <div style={{ textAlign: 'right', margin: '10px 0' }}>
          <a
            onClick={() => {
              toast.dismiss(this.commToaster);
              window.location.href = program.url;
              const dialog = Dialog.confirm({
                title: '🚧',
                content: formatMessage('system.comm.download.success', null, {
                  program: program.name,
                }),
                footer: <Button onClick={() => dialog.hide()}>{formatMessage('ok')}</Button>,
              });
            }}
            style={{ color: Colors.primary, fontWeight: '500', marginRight: 10 }}
          >
            🔗&nbsp;{formatMessage('system.comm.update.download')}
          </a>
          <a
            onClick={() => this.toggleCommUpdater(false)}
            style={{ color: Colors.lightGrey, fontWeight: '500', marginRight: 10 }}
          >
            🚫&nbsp;{formatMessage('system.comm.update.ignore')}
          </a>
          <a
            onClick={() => toast.dismiss(this.commToaster)}
            style={{ color: Colors.lightGrey, fontWeight: '500' }}
          >
            🤔&nbsp;{formatMessage('profile.notify.email.no')}
          </a>
        </div>
      </div>
    );

    this.commToaster = toast(content, {
      position: 'top-right',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  dontUseSDK = () => {
    setConfig(Object.assign(getConfig(), { disableSDK: true }));
    // TODO: 连接失败的情况下，禁止连接后，后台仍再不停的重连，下次刷新页面才会避免这个问题（因为直接不再连接了）;
    // disconnectSdk();
    stopReconnect();
  };

  logout = () => {
    isInitialLoad = true;
    logout().then(
      () => {},
      () => {
        // TODO: 这里需要对错误进行一遍覆盖，比如用prompt，防止再出错情况下误导用户
      }
    );
    // 加个500ms的延迟，防止在接口加入token前已经进入到登陆界面并且把token删除掉;
    setTimeout(() => {
      // TODO: 返回会有问题吗？可能返回这个页面的上一个路由;
      this.props.history.replace('/login');
      // 无论后台给什么结果，都删除token并且回到登陆页面
      // 目前更新为这里再手动清除token，因为登陆界面加载时会自动清空token;
      // removeToken();
      // Feedback.toast.prompt('已注销当前用户！');
    }, 500);
  };

  getSocketService = () => {
    // getSocketService('通讯组件.zip').then(() => {
    //     Feedback.toast.success('即将开始下载通讯组件...')
    // }, err => { });
    getSocketLink().then(data => {
      Feedback.toast.success(formatMessage('profile.comm.program.downloading'));
      // TODO: 直接通过改变href来完成下载，会由什么隐患吗？
      window.location.href = data;
    });
  };

  readKeyInfo = () => {
    this.keyConnector.open();
  };

  // 钥匙授权
  onAuthKey = () => {
    const authperiod = getProfile().authperiod || this.props.authperiod;
    const beginDate = moment(new Date()).format('YYYY-MM-DD');
    const endDate = moment(beginDate)
      .add(authperiod - 1, 'd')
      .format('YYYY-MM-DD');

    this.authKeyConnector.open(null, {
      title: formatMessage('key.authority.title'),
      desc: formatMessage('key.authority.desc', '', { count: 1 }),
      onKeyConnected: (id, key) => {
        getKey(id).then(
          async result => {
            if (!result) {
              Feedback.toast.error(formatMessage('key.takeout.notexsit'));
              this.authKeyConnector.setLoading(false);
              return;
            }
            if (!result.unlocknos || result.unlocknos.length === 0) {
              Feedback.toast.error(formatMessage('key.authority.lock.required'));
              this.authKeyConnector.setLoading(false);
              return;
            }
            if (result && result.keytype === 12) {
              Feedback.toast.error(formatMessage('key.connector.emergency'));
              this.authKeyConnector.setLoading(false);
              return;
            }

            // 判断是否为指纹钥匙的依据来自后台存储的钥匙类型，使用读取钥匙后返回的类型也是可以的
            const isFingerprintKey = fingerprint_keytypes.includes(result.keytype);
            if (isFingerprintKey) {
              try {
                // 判断钥匙本部门指纹数量是否大于100
                const fingerCount = await getFingers(result.dept);
                if (fingerCount && fingerCount > 100) {
                  Feedback.toast.error(formatMessage('key.authority.fingers'));
                  this.authKeyConnector.setLoading(false);
                  return;
                }
              } catch (error) {
                console.error('获取指纹数量失败:', error);
                this.authKeyConnector.setLoading(false);
              }
            }

            if (result.keystatus !== 0) {
              // 这里不会再出现领出状态
              Feedback.toast.error(
                formatMessage('key.takeout.abnormal', '', {
                  status: this.keystatus.slice(1)[result.keystatus].name,
                })
              );
              this.authKeyConnector.setLoading(false);
            } else {
              // 1288标志，低于260版本的指纹蓝牙钥匙，不支持下载离线任务，会当做在线钥匙来处理，所以索性不让下载；
              if (key.device === 1288 && key.ver < 260 && result.offline === 1) {
                Feedback.toast.error(formatMessage('task.download.offline.notallow'));
                this.authKeyConnector.setLoading(false);
                return;
              }

              // 验证钥匙授权合法性
              const autherNum = await getKeyAuther(id);
              if (autherNum === 0) {
                Feedback.toast.error(formatMessage('key.authority.user.required'));
                this.authKeyConnector.setLoading(false);
                return;
              }

              try {
                await this.checkExistRecords(key);
                await createBlankKey(id);
              } catch (e) {
                if (e) Feedback.toast.error(e);
                this.authKeyConnector.setLoading(false);
                return;
              }

              const { unlocknos, workerlist } = result;
              const downloadTimeranges = [['00:00:00', '23:59:59']];
              const timeParams = [
                beginDate,
                endDate, // 结束增加一天，否则可能不包含结束当天;
                downloadTimeranges,
              ];
              const unlockParams = [...timeParams, unlocknos.map(l => l), 1];

              if (isFingerprintKey) {
                const fingerprints = workerlist
                  .filter(w => w.fingerprints && w.fingerprints.length > 0)
                  .map(w => w.fingerprints);
                if (fingerprints.length > 0) {
                  const flatFingerprints = !isIE()
                    ? fingerprints.flat()
                    : fingerprints.reduce((acc, val) => acc.concat(val), []);

                  if (flatFingerprints.length > 0) {
                    unlockParams.push(undefined, flatFingerprints);
                    this.setState({ downloadingFingerprint: true });
                  }
                }
              }
              console.log('unlockParams', unlockParams);

              createUnlockKey(...unlockParams)
                .then(
                  () => {
                    Feedback.toast.success(formatMessage('key.authority.success'));
                    this.authKeyConnector.close();

                    createKeyDownloadRecord(id, beginDate, endDate).then(
                      () => {
                        EventEmitter.emit(AUTH_KEY_SUCCEED);
                      },
                      () => {}
                    );
                  },
                  err => {
                    Feedback.toast.error(err);
                    this.setState({ downloadingFingerprint: false });
                  }
                )
                .finally(() => this.authKeyConnector.setLoading(false));
            }
          },
          () => {
            this.authKeyConnector.setLoading(false);
          }
        );
      },
    });
  };

  // 判断钥匙中是否存在未读取的开关锁记录
  checkExistRecords = key => {
    return new Promise((resolve, reject) => {
      const askUpload = () => {
        const dialog = Dialog.confirm({
          title: formatMessage('key.back.unread.dialog.notice'),
          content: formatMessage(
            ASK_READ_UNREAD_EVENT_BEFORE_GIVEBACK
              ? 'key.back.unread.dailog.content'
              : 'key.back.unread.dailog.content.force'
          ),
          // closable: 'close,mask,esc',
          closable: 'close',
          onClose: () => {
            if (this.connector) {
              this.connector.setLoading(false);
            }
            if (this.authKeyConnector) {
              this.authKeyConnector.setLoading(false);
            }
            reject();
          },
          footer: (
            <div>
              {ASK_READ_UNREAD_EVENT_BEFORE_GIVEBACK && (
                <Button
                  onClick={() => {
                    dialog.hide();
                    resolve();
                  }}
                >
                  {formatMessage('key.back.unread.cancel')}
                </Button>
              )}
              <Button
                type="primary"
                onClick={() => {
                  dialog.hide();
                  if (this.connector) {
                    this.connector.setLoading(false);
                    this.connector.close();
                  }
                  if (this.authKeyConnector) {
                    this.authKeyConnector.setLoading(false);
                    this.authKeyConnector.close();
                  }
                  this.props.history.push('/record/lock/reader');
                }}
              >
                {formatMessage('key.back.unread.confirm')}
              </Button>
            </div>
          ),
        });
      };
      if (isWMAdvancedUnlock()) {
        // TODO: 实测非主任务钥匙，也有recordCount？？？
        if (key.recordCount > 0) {
          askUpload();
        } else {
          resolve();
        }
      } else {
        readUnlockRecords(false).then(
          unlockEvents => {
            console.log('readUnlockRecords', unlockEvents);
            if (unlockEvents.length > 0) {
              askUpload();
            } else {
              resolve();
            }
          },
          err => {
            // if (err) Feedback.toast.error(err);
            reject(err);
            this.connector.setLoading(false);
          }
        );
      }
    });
  };
}

// 导出一个重置是否首次加载的标志方法，用于在将系统升级到Official License时，重新登录系统允许重新注册SDK;
// TODO: 放到store中管理更好一些;
export function resetIsInitialLoad() {
  isInitialLoad = true;
}

function mapStateToProps(store) {
  return {
    profileResult: store.profileReducer.profile,
    sdkResult: store.sdkReducer,

    mqttConnection: store.mqttReducer.connection,
    disableCommUpdater: store.systemReducer.disableCommUpdater,
  };
}

export default connect(mapStateToProps)(Initializer);
